/* AMOYA theme behaviour. Loaded after Dawn's global.js. */
(function () {
  'use strict';

  var Amoya = (window.Amoya = window.Amoya || {});
  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktop = window.matchMedia('(min-width: 990px)');
  var tablet = window.matchMedia('(min-width: 750px)');
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  root.classList.add('am-js');

  function define(name, constructor) {
    if (!customElements.get(name)) customElements.define(name, constructor);
  }

  function onMediaChange(query, callback) {
    if (query.addEventListener) query.addEventListener('change', callback);
    else if (query.addListener) query.addListener(callback);
  }

  /* ---------- Toast ---------- */

  var toastTimer;
  Amoya.toast = function (message) {
    var toast = document.querySelector('.am-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'am-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 4200);
  };

  /* ---------- Reveal on scroll ---------- */

  var revealObserver =
    'IntersectionObserver' in window && !designMode
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-in');
              revealObserver.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
        )
      : null;

  Amoya.reveal = function (scope) {
    (scope || document).querySelectorAll('.am-reveal:not(.is-in), .am-reveal-img:not(.is-in)').forEach(function (el) {
      if (revealObserver && !reduceMotion.matches) revealObserver.observe(el);
      else el.classList.add('is-in');
    });
  };

  /* ---------- Cart helpers ---------- */

  Amoya.addToCart = function (items) {
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message || 'Error');
        if (drawer && drawer.classList.contains('active') && state.sections) {
          // Already open (adding from the bag itself): swap the contents in place
          drawer.classList.remove('is-empty');
          drawer.getSectionsToRender().forEach(function (section) {
            var target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            var html = state.sections[section.id];
            if (target && html) target.innerHTML = drawer.getSectionInnerHTML(html, section.selector);
          });
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
          var inner = drawer.querySelector('.drawer__inner');
          if (typeof trapFocus === 'function' && inner) trapFocus(document.getElementById('CartDrawer'), inner);
        } else if (drawer) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
        } else {
          window.location = window.routes.cart_url;
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'amoya', cartData: state });
        }
        return state;
      });
  };

  define(
    'am-quick-add',
    class AmQuickAdd extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button || this.bound) return;
        this.bound = true;
        this.button.addEventListener('click', this.add.bind(this));
      }

      add() {
        if (this.classList.contains('is-loading')) return;
        var ids = String(this.dataset.variantId || '')
          .split(',')
          .map(function (id) { return parseInt(id, 10); })
          .filter(Boolean);
        if (!ids.length) return;
        var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
        var label = this.button.querySelector('span');
        var original = label ? label.textContent : '';
        this.classList.add('is-loading');
        this.button.setAttribute('aria-busy', 'true');
        Amoya.addToCart(items)
          .then(() => {
            if (label && this.dataset.doneLabel) label.textContent = this.dataset.doneLabel;
          })
          .catch(function (error) {
            Amoya.toast(error.message);
          })
          .finally(() => {
            this.classList.remove('is-loading');
            this.button.removeAttribute('aria-busy');
            if (label && this.dataset.doneLabel) {
              setTimeout(function () { label.textContent = original; }, 2400);
            }
          });
      }
    }
  );

  /* ---------- Announcement rotator ---------- */

  define(
    'am-rotator',
    class AmRotator extends HTMLElement {
      connectedCallback() {
        this.items = Array.prototype.slice.call(this.querySelectorAll('.am-announce__item'));
        if (this.items.length < 2 || this.started) return;
        this.started = true;
        this.index = Math.max(0, this.items.findIndex(function (item) { return item.classList.contains('is-active'); }));
        this.interval = parseInt(this.dataset.interval, 10) || 5000;
        this.querySelectorAll('[data-rotate]').forEach((button) => {
          button.addEventListener('click', () => {
            this.go(this.index + parseInt(button.dataset.rotate, 10));
            this.play();
          });
        });
        this.addEventListener('mouseenter', this.pause.bind(this));
        this.addEventListener('mouseleave', this.play.bind(this));
        this.addEventListener('focusin', this.pause.bind(this));
        this.addEventListener('focusout', this.play.bind(this));
        document.addEventListener('shopify:block:select', (event) => {
          var i = this.items.indexOf(event.target);
          if (i > -1) {
            this.pause();
            this.go(i);
          }
        });
        this.play();
      }

      disconnectedCallback() {
        this.pause();
      }

      go(index) {
        var count = this.items.length;
        this.index = ((index % count) + count) % count;
        this.items.forEach((item, i) => {
          var active = i === this.index;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', active ? 'false' : 'true');
          var link = item.querySelector('a');
          if (link) link.setAttribute('tabindex', active ? '0' : '-1');
        });
      }

      play() {
        this.pause();
        if (reduceMotion.matches) return;
        this.timer = setInterval(() => this.go(this.index + 1), this.interval);
      }

      pause() {
        clearInterval(this.timer);
      }
    }
  );

  /* ---------- Header: sticky reveal, transparency, mega menu ---------- */

  define(
    'am-header',
    class AmHeader extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.mode = this.dataset.sticky || 'reveal';
        this.transparent = this.dataset.transparent === 'true';
        this.lastY = window.scrollY;
        this.ticking = false;
        this.megaOpen = null;

        window.addEventListener('scroll', this.queue.bind(this), { passive: true });
        this.addEventListener('mouseenter', () => {
          this.hovering = true;
          this.update();
        });
        this.addEventListener('mouseleave', () => {
          this.hovering = false;
          this.update();
        });

        var burger = this.querySelector('[data-drawer-open]');
        if (burger) {
          burger.addEventListener('click', function (event) {
            var drawer = document.getElementById(burger.getAttribute('aria-controls'));
            if (drawer && drawer.open) drawer.open(event.currentTarget);
          });
        }

        var search = this.querySelector('.am-search details');
        if (search) {
          search.addEventListener('toggle', () => {
            this.searchOpen = search.open;
            if (search.open) this.closeMega();
            this.update();
          });
        }

        this.initMega();
        this.update();
      }

      queue() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      }

      update() {
        var y = Math.max(0, window.scrollY);
        var busy = this.searchOpen || !!this.megaOpen || document.body.classList.contains('overflow-hidden');

        if (this.transparent) {
          var solid = y > 24 || busy || (this.hovering && desktop.matches);
          this.classList.toggle('is-transparent', !solid);
        }

        this.classList.toggle('is-scrolled', y > 8);

        if (this.mode !== 'reveal') return;
        var delta = y - this.lastY;
        if (busy || y < 160) {
          this.setHidden(false);
          this.lastY = y;
          return;
        }
        if (Math.abs(delta) < 8) return;
        this.setHidden(delta > 0);
        this.lastY = y;
      }

      setHidden(hidden) {
        this.classList.toggle('is-hidden', hidden);
        document.body.classList.toggle('am-header-hidden', hidden);
      }

      initMega() {
        var items = Array.prototype.slice.call(this.querySelectorAll('[data-mega]'));
        if (!items.length) return;

        items.forEach((item) => {
          var button = item.querySelector('.am-nav__link');
          var openTimer;
          item.addEventListener('mouseenter', () => {
            if (!desktop.matches || !window.matchMedia('(hover: hover)').matches) return;
            clearTimeout(this.closeTimer);
            openTimer = setTimeout(() => this.openMega(item), this.megaOpen ? 0 : 90);
          });
          item.addEventListener('mouseleave', () => {
            clearTimeout(openTimer);
            this.closeTimer = setTimeout(() => {
              if (this.megaOpen === item) this.closeMega();
            }, 200);
          });
          button.addEventListener('click', () => {
            if (this.megaOpen === item) this.closeMega();
            else this.openMega(item);
          });
          item.addEventListener('focusout', (event) => {
            if (this.megaOpen === item && !item.contains(event.relatedTarget)) this.closeMega();
          });
        });

        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !this.megaOpen) return;
          var button = this.megaOpen.querySelector('.am-nav__link');
          this.closeMega();
          if (button) button.focus();
        });

        document.addEventListener('click', (event) => {
          if (this.megaOpen && !this.contains(event.target)) this.closeMega();
        });

        onMediaChange(desktop, () => this.closeMega());
      }

      openMega(item) {
        if (this.megaOpen && this.megaOpen !== item) this.closeMega(true);
        item.classList.add('is-open');
        var button = item.querySelector('.am-nav__link');
        if (button) button.setAttribute('aria-expanded', 'true');
        this.megaOpen = item;
        document.body.classList.add('am-mega-open');
        this.update();
      }

      closeMega(switching) {
        if (!this.megaOpen) return;
        this.megaOpen.classList.remove('is-open');
        var button = this.megaOpen.querySelector('.am-nav__link');
        if (button) button.setAttribute('aria-expanded', 'false');
        this.megaOpen = null;
        if (!switching) document.body.classList.remove('am-mega-open');
        this.update();
      }
    }
  );

  /* ---------- Mobile menu drawer ---------- */

  define(
    'am-drawer',
    class AmDrawer extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.panel = this.querySelector('.am-drawer__panel');
        this.querySelectorAll('[data-drawer-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });
        this.querySelectorAll('[data-sub-open]').forEach((button) => {
          button.addEventListener('click', () => this.openSub(button));
        });
        this.querySelectorAll('[data-sub-close]').forEach((button) => {
          button.addEventListener('click', () => this.closeSub(button.closest('[data-sub]')));
        });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          var sub = this.querySelector('.am-drawer__sub.is-open');
          if (sub) this.closeSub(sub);
          else this.close();
        });
        onMediaChange(desktop, (event) => {
          if (event.matches && this.isOpen) this.close();
        });
      }

      open(opener) {
        this.opener = opener || document.activeElement;
        this.hidden = false;
        this.isOpen = true;
        clearTimeout(this.hideTimer);
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.classList.add('is-open'));
        });
        document.body.classList.add('overflow-hidden');
        if (this.opener && this.opener.setAttribute) this.opener.setAttribute('aria-expanded', 'true');
        setTimeout(() => {
          if (typeof trapFocus === 'function') trapFocus(this.panel, this.panel.querySelector('.am-drawer__link') || this.panel);
          else this.panel.focus();
        }, 60);
      }

      close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
        if (this.opener && this.opener.setAttribute) this.opener.setAttribute('aria-expanded', 'false');
        if (typeof removeTrapFocus === 'function') removeTrapFocus(this.opener);
        else if (this.opener && this.opener.focus) this.opener.focus();
        this.hideTimer = setTimeout(() => {
          if (this.isOpen) return;
          this.hidden = true;
          this.querySelectorAll('.am-drawer__sub.is-open').forEach(function (sub) {
            sub.classList.remove('is-open');
          });
          this.querySelectorAll('.am-drawer__body.has-sub').forEach(function (body) {
            body.classList.remove('has-sub');
          });
          this.querySelectorAll('[data-sub-open]').forEach(function (button) {
            button.setAttribute('aria-expanded', 'false');
          });
        }, 500);
      }

      openSub(button) {
        var sub = document.getElementById(button.getAttribute('aria-controls'));
        if (!sub) return;
        // The panel is sized to the visible part of the body, so start it from the top
        var body = sub.closest('.am-drawer__body');
        if (body) {
          body.scrollTop = 0;
          body.classList.add('has-sub');
        }
        sub.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        setTimeout(function () {
          if (typeof trapFocus === 'function') trapFocus(sub, sub.querySelector('[data-sub-close]'));
        }, 80);
      }

      closeSub(sub) {
        if (!sub) return;
        sub.classList.remove('is-open');
        var body = sub.closest('.am-drawer__body');
        if (body) body.classList.remove('has-sub');
        var button = this.querySelector('[aria-controls="' + sub.id + '"]');
        if (button) button.setAttribute('aria-expanded', 'false');
        if (typeof trapFocus === 'function') trapFocus(this.panel, button);
      }
    }
  );

  /* ---------- Rails: arrows and progress bar for scroll rows ---------- */

  define(
    'am-rail',
    class AmRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rail-track]');
        if (!this.track || this.ready) return;
        this.ready = true;
        this.prev = this.querySelector('[data-rail-prev]');
        this.next = this.querySelector('[data-rail-next]');
        this.bar = this.querySelector('[data-rail-bar]');
        if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
        if (this.next) this.next.addEventListener('click', () => this.step(1));
        this.track.addEventListener('scroll', this.queue.bind(this), { passive: true });
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.queue.bind(this));
          this.observer.observe(this.track);
        } else {
          window.addEventListener('resize', this.queue.bind(this));
        }
        this.queue();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      step(direction) {
        var first = this.track.firstElementChild;
        if (!first) return;
        var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        var width = first.getBoundingClientRect().width + gap;
        var perView = Math.max(1, Math.floor((this.track.clientWidth + gap) / width));
        this.track.scrollBy({ left: direction * width * perView, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }

      queue() {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(this.sync.bind(this));
      }

      sync() {
        var track = this.track;
        var max = track.scrollWidth - track.clientWidth;
        var left = Math.abs(track.scrollLeft);
        if (this.prev) this.prev.disabled = left <= 2;
        if (this.next) this.next.disabled = left >= max - 2;
        this.classList.toggle('is-static', max <= 2);
        if (!this.bar || !track.scrollWidth) return;
        var ratio = Math.min(1, track.clientWidth / track.scrollWidth);
        var position = max > 0 ? left / max : 0;
        this.bar.style.setProperty('--am-bar-w', ratio * 100 + '%');
        this.bar.style.setProperty('--am-bar-x', position * (1 / ratio - 1) * 100 + '%');
      }
    }
  );

  /* ---------- Tabs ---------- */

  define(
    'am-tabs',
    class AmTabs extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => {
            var next = null;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === null) return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus();
          });
        });
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          var active = i === index;
          var panel = document.getElementById(tab.getAttribute('aria-controls'));
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
          if (!panel) return;
          if (active && panel.hidden) {
            panel.hidden = false;
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
            Amoya.reveal(panel);
            panel.querySelectorAll('.am-reveal, .am-reveal-img').forEach(function (el) {
              el.classList.add('is-in');
            });
          } else if (!active) {
            panel.hidden = true;
          }
        });
        var activeTab = this.tabs[index];
        var list = this.querySelector('.am-tabs__list');
        if (activeTab && list && list.scrollWidth > list.clientWidth) {
          var tabLeft = activeTab.offsetLeft - list.offsetLeft;
          if (tabLeft < list.scrollLeft || tabLeft + activeTab.offsetWidth > list.scrollLeft + list.clientWidth) {
            list.scrollTo({ left: tabLeft - 16, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          }
        }
      }
    }
  );

  /* ---------- Delivery estimate (business days, skips weekends) ---------- */

  function addBusinessDays(date, days) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return result;
  }

  define(
    'am-delivery',
    class AmDelivery extends HTMLElement {
      connectedCallback() {
        var output = this.querySelector('[data-delivery-dates]');
        if (!output) return;
        var dispatchMin = parseInt(this.dataset.dispatchMin, 10) || 1;
        var dispatchMax = parseInt(this.dataset.dispatchMax, 10) || dispatchMin;
        var transitMin = parseInt(this.dataset.transitMin, 10) || 2;
        var transitMax = parseInt(this.dataset.transitMax, 10) || transitMin;
        var now = new Date();
        var from = addBusinessDays(now, dispatchMin + transitMin);
        var to = addBusinessDays(now, dispatchMax + transitMax);
        var locale = document.documentElement.lang || 'en-GB';
        if (locale === 'en') locale = 'en-GB';
        var format = function (date) {
          try {
            return date.toLocaleDateString(locale, { weekday: 'short', day: 'numeric', month: 'short' });
          } catch (e) {
            return date.toDateString();
          }
        };
        output.textContent = format(from) === format(to) ? format(from) : format(from) + ' – ' + format(to);
        this.hidden = false;
      }
    }
  );

  /* ---------- Recently viewed ---------- */

  var RECENT_KEY = 'amoya:recent';

  function readRecent() {
    try {
      return JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  define(
    'am-recent',
    class AmRecent extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        var current = this.dataset.handle;
        var limit = parseInt(this.dataset.limit, 10) || 4;
        var list = readRecent().filter(function (handle) { return handle && handle !== current; });
        if (current) {
          try {
            localStorage.setItem(RECENT_KEY, JSON.stringify([current].concat(list).slice(0, 12)));
          } catch (e) {
            /* storage can be blocked; the section just stays hidden */
          }
        }
        if (designMode || !list.length) return;
        var grid = this.querySelector('[data-recent-grid]');
        if (!grid) return;
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var requests = list.slice(0, limit).map(function (handle) {
          return fetch(base + 'products/' + encodeURIComponent(handle) + '?view=amcard')
            .then(function (response) {
              return response.ok ? response.text() : '';
            })
            .catch(function () {
              return '';
            });
        });
        Promise.all(requests).then((cards) => {
          var html = cards
            .filter(function (card) { return card && card.indexOf('am-card') > -1; })
            .map(function (card) { return '<li>' + card + '</li>'; })
            .join('');
          if (!html) return;
          grid.innerHTML = html;
          this.hidden = false;
          var section = this.closest('.shopify-section');
          if (section) section.classList.add('has-recent');
        });
      }
    }
  );

  /* ---------- Footer columns: open on desktop, collapsed on phones ---------- */

  function syncFooter() {
    document.querySelectorAll('.am-footer__details').forEach(function (details) {
      if (tablet.matches) details.setAttribute('open', '');
      else if (!details.dataset.touched) details.removeAttribute('open');
    });
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('.am-footer__details > summary');
    if (!summary) return;
    if (tablet.matches) {
      event.preventDefault();
      return;
    }
    summary.parentElement.dataset.touched = 'true';
  });

  onMediaChange(tablet, syncFooter);

  /* ---------- Video autoplay respects reduced motion ---------- */

  function syncVideos(scope) {
    (scope || document).querySelectorAll('video[data-am-autoplay]').forEach(function (video) {
      if (reduceMotion.matches) {
        video.pause();
        video.removeAttribute('autoplay');
      } else {
        var play = video.play();
        if (play && play.catch) play.catch(function () {});
      }
    });
  }

  /* ---------- Boot ---------- */

  function boot() {
    Amoya.reveal();
    syncFooter();
    syncVideos();
    Amoya.ready = true;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    Amoya.reveal(event.target);
    syncFooter();
    syncVideos(event.target);
  });
})();
